const CoraSGRModuleSubcategory = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4363_29283)" />
    <g clip-path="url(#clip0_4363_29283)">
      <path
        d="M31.3228 24.1545C32.0614 24.7011 31.8257 26.0129 30.9299 26.372C29.987 26.7312 27.6454 26.4345 26.4981 26.5126C23.7008 26.7 20.9506 28.5896 19.6619 31.0413C16.8646 36.4133 20.3848 42.7848 26.341 43.4875C26.7182 43.5343 28.1483 43.6437 28.4154 43.55C29.0598 43.3313 27.8339 40.4892 29.5312 40.7078L35.2045 44.3464C35.4717 44.6899 35.4402 45.2053 35.0788 45.4864C33.4129 46.439 31.8257 47.7351 30.1756 48.6565C29.7198 48.9063 29.2798 49.2343 28.824 48.7502C28.3683 48.2661 28.6197 47.782 28.6197 47.2822C28.6197 47.1886 28.5569 47.0792 28.5569 46.9699C28.5569 46.7981 28.7454 46.3765 28.5569 46.236C28.4154 46.1423 27.1425 46.236 26.8282 46.2047C18.9233 45.6425 13.7215 37.8344 17.006 30.4479C19.3633 25.1696 24.6594 23.3581 30.207 23.7954C30.6156 23.8266 31.0085 23.9047 31.3385 24.1545H31.3228Z"
        fill="white"
      />
      <path
        d="M41.3966 28.7769C41.3337 29.0424 40.8308 29.3391 40.5637 29.2923L34.9061 25.7474C34.4818 25.3882 34.5918 24.6698 35.079 24.42C36.7134 23.5298 38.2849 22.2181 39.8879 21.3123C40.2651 21.1093 40.5165 20.8907 40.9723 21.0625C41.7895 21.3904 41.1609 23.077 41.4752 23.7641C44.0368 23.7797 46.3784 24.1545 48.5943 25.4663C54.2047 28.7925 55.6977 36.2571 51.8945 41.5354C49.05 45.4707 44.3668 46.6419 39.6679 46.2203C37.8135 46.0485 37.7035 43.6749 39.8251 43.5031C41.5223 43.3781 43.1253 43.6905 44.8226 43.3001C50.4016 41.9727 53.0575 35.5075 50.0873 30.604C48.3271 27.715 44.9483 26.2627 41.6009 26.4813C41.538 26.4813 41.3809 26.6375 41.3809 26.6531C41.3809 27.1997 41.4752 28.3553 41.3809 28.8082L41.3966 28.7769Z"
        fill="white"
      />
      <path
        d="M31.4959 34.1958C29.9087 32.3843 32.5489 31.0413 34.1361 30.9007C35.7234 30.7602 38.5993 31.5098 38.175 33.5555C37.7192 35.7418 32.926 35.8355 31.4959 34.2114V34.1958Z"
        fill="white"
      />
      <path
        d="M31.3382 37.1315C31.3382 37.1315 31.5739 37.4751 31.7154 37.5844C33.2555 38.8337 35.9743 38.8493 37.5301 37.6156C37.7501 37.4438 38.1116 36.7723 38.1901 37.3814C38.3473 38.7088 36.32 39.4583 35.2513 39.5677C33.6327 39.7238 30.8982 39.1773 31.0553 37.1003C31.1496 37.1003 31.2753 37.0691 31.3539 37.1159L31.3382 37.1315Z"
        fill="white"
      />
      <path
        d="M31.4011 35.242C32.9255 36.6319 35.4871 37.0223 37.2473 35.7418C37.4201 35.6168 38.0331 34.8829 38.1902 35.039C38.3316 35.8979 37.7345 36.5538 37.0115 36.9442C35.5029 37.725 33.0512 37.6626 31.6997 36.6007C31.3383 36.3039 30.8197 35.4763 31.1811 35.0546C31.3225 35.0234 31.3383 35.1952 31.4168 35.2577L31.4011 35.242Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4363_29283"
        x1="34.5455"
        y1="2.70945e-07"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7000FF" />
        <stop offset="1" stop-color="#45009C" />
      </linearGradient>
      <clipPath id="clip0_4363_29283">
        <rect width="38" height="28" fill="white" transform="translate(16 21)" />
      </clipPath>
    </defs>
  </svg>
)

export default CoraSGRModuleSubcategory
